import { Company } from "./company";

export class Vehicle {
  id: string;
  brand: string;
  webObjectId: string;
  model: string;
  immat: string;
  color: string;
  vin: string;
  circulationDate: Date;
  recordingDate: Date;
  total: number;
  categorie: number;
  cle: number;
  capaciteReservoir: number;
  jauge: number;
  kilometrage: number;

  constructor() {}

  /*constructor(id: number, brand: string, model: string, color: string, immat: string, vin: string, circulationDate: Date, recordingDate: Date, idCompany: number) {
        this.id = id;
        this.brand = brand;
        this.model = model;
        this.color = color;
        this.immat = immat;
        this.vin = vin;
        this.circulationDate = circulationDate;
        this.recordingDate = recordingDate;
        this.idCompany = idCompany;
    }*/
}



// WEBPACK FOOTER //
// ./src/app/model/vehicle.ts